import { type CofConfigId } from "../../gql-generated/types";
import { isDev, isLocal } from "../../shared/constants";
import { LocalStorage } from "../../shared/utils/browser";

import { type ConfigMap } from "./ConfigMap";
import { cofConfigIds, cofConfigIdsMap } from "./cofConfigIdsMap";

const overridesStoreKey = "sc-config-overrides";

const entries = cofConfigIds.map((configId: CofConfigId) => {
    const { type, localDefault } = cofConfigIdsMap[configId];

    return [
        configId,
        {
            type,
            value: localDefault,
        },
    ] as const;
});

const defaultConfigMap: ConfigMap = Object.fromEntries(entries);

export class OverridesStore extends LocalStorage {
    constructor(public override key: string) {
        super(key);

        const store = this.getItem<ConfigMap>();
        if (!store) {
            super.setItem(defaultConfigMap);
        }
    }
}

export const overridesStore = isLocal() || isDev() ? new OverridesStore(overridesStoreKey) : null;
